export const LightThemeColors = {
  primary: { main: "#2C6150", light: "#C6E5F8", dark: "#1A7AAA" },
  secondary: { main: "#6691E6", light: "#C3D7EC", dark: "#dedee3" },
  background: {
    default: "#F9FAFA",
    light: "#F1F2F3",
  },
  text: {
    primary: "#0C0C0E",
    secondary: "#0C0C0E",
  },
  chip: {
    greenShade: "#57A7731A",
    redShade: "#E561521A",
    greenText: "#57A773",
    redText: "#E56152",
  },

  button: {
    main: "#2C6150",
  },
};
